<template>
  <div>
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
    <transition name="fade">
      <div id="playposit-error-screen" v-if="$root.enabled" :style="errorScreenStyle">
        <div
          v-if="$root.enableLogo !== false"
          class="playposit-block"
        >
          <img :src="errorScreenLogo" width="100px">
        </div>
        <div v-if="$root.code" class="status-code-block">
          [{{$root.code}}]
        </div>
        <div class="error-block">
          <div class="error-headline-block" :class="{'vertical': $root.vertical}">
            <div class="error-icon-block">
              <i class="error-icon material-icons white--text" v-if="$root.icon">{{$root.icon}}</i>
            </div>
            <div class="error-title-block">
              <h1 autofocus role="alert" class="error-title" :class="{'text-center': $root.vertical}" tabindex="0" :aria-label="$root.title">{{$root.title}}</h1>
              <h2 class="error-subtitle" :class="{'text-center': $root.vertical || $root.center_subtitle}" v-if="$root.subtitle" tabindex="0" :aria-label="$root.subtitle">{{$root.subtitle}}</h2>
            </div>
          </div>
          <div class="error-message-block" v-if="$root.text && $root.text.length">
            <div class="error-details-text">Details:</div>
            <pre class="error-details-block" v-html="$root.text" tabindex="0" :aria-label="errorMessageBlockAriaLabel"></pre>
          </div>
          <div class="error-actions-block" :style="`margin-top: ${($root.text && $root.text.length) ? '0' : '24px'}`" v-if="$root.buttons && $root.buttons.length">
            <template v-for="(button, idx) in processedButtons">
              <a v-if="button.action === 'help'" class="error-screen-button" :style="`color: ${['outline', 'flat'].includes(button.type) ? $root.inactive_color : $root.active_color}`" :key="idx" href="mailto:help@playposit.org" :class="button.type" aria-label="Help button">
                Help
              </a>
              <a v-else-if="button.href" class="error-screen-button" :style="`color: ${['outline', 'flat'].includes(button.type) ? $root.inactive_color : $root.active_color}`" :key="idx" :href="button.href" :class="button.type" :aria-label="button.text + 'button'">
                {{button.text}}
              </a>
              <button v-else class="error-screen-button" :style="`color: ${['outline', 'flat'].includes(button.type) ? $root.inactive_color : $root.active_color}`" :key="idx" @click="performButtonAction(button)" :class="button.type" :aria-label="button.text + 'button'"  >
                {{button.text}}
              </button>
            </template>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable */
/* global location */
'use strict';
import _ from 'lodash';

export default {
  name: 'playposit-error-screen',
  computed: {
    enabled() {
      return this.$root.enabled;
    },
    action_strings() {
      return [
        'reload',
        'refresh',
        'return'
      ];
    },
    errorScreenLogo() {
      if (_.get(this.$root, 'logoURL')) return this.$root.logoURL;
      return 'https://bunny.playposit.com/images/logo_white.png';
    },
    errorScreenStyle() {
      return {
        backgroundColor: this.$root.active_color
      };
    },
    processedButtons() {
      return _.orderBy(this.$root.buttons, 'order').reverse();
    },
    errorMessageBlockAriaLabel() {
      return  this.$options.filters.stripHTML(this.$root.text);
    },
  },
  filters: {
    stripHTML: (value) => {
      const div = document.createElement('div')
      div.innerHTML = value
      const text = div.textContent || div.innerText || ''
      return text;
    }
  },
  methods: {
    actionCloseWindow() {
      window.close();
    },
    actionCloseBluescreen() {
      this.$root.enabled = false;
    },
    actionRefresh() {
      location.reload();
    },
    actionReturn() {
      window.history.go(-1);
    },
    actionRedirect(url) {
      window.location.href = url;
    },
    performButtonAction(button) {
      if (typeof button.action === 'string') {
        if (this.action_strings.includes(button.action)) {
          if (['reload', 'refresh'].includes(button.action)) {
            this.actionRefresh();
          } else if (['return'].includes(button.action)) {
            this.actionReturn();
          }
        } else if (button.action.includes('http://') || button.action.includes('https://')) {
          this.actionRedirect(button.action);
        } else if (['close'].includes(button.action)) {
          this.actionCloseWindow();
        } else if (['disable'].includes(button.action)) {
          this.actionCloseBluescreen();          
        } else {
          this.actionRefresh();
        }
      } else if (typeof button.action === 'function') {
        button.action();
      } else {
        this.actionRefresh();
      }
    }
  },
};
</script>

<style lang="scss" scoped>

  /* BEGIN CSS RESET */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  /* END CSS RESET */

  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;
    /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;
    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;
    /* Support for IE. */
    font-feature-settings: 'liga';
  }

  *:not(.material-icons) {
    font-family: 'Roboto';
  }

  #playposit-error-screen {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2147483647;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }

  .text-center {
    text-align: center;
  }

  .playposit-block {
    position: fixed;
    top: 1rem;
    left: 0.5rem;
  }

  .status-code-block {
    position: fixed;
    top: 0.65rem;
    right: 0.5rem;
    font-size: 11px;
    color: rgba(255,255,255,0.8);
  }

  .error-block {
    width: 100%;
    max-width: 540px;
  }

  .error-headline-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .error-icon-block {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  i.error-icon {
    font-size: 100px;
  }

  .error-title-block {
    padding-left: 16px;
  }

  .error-title {
    text-align: center;
    font-size: 50px;
    color: white;
    position: relative;
    left: -3px;
  }

  .error-subtitle {
    font-size: 30px;
    color: rgba(255,255,255,0.8);
  }

  .error-message-block {
    margin: 48px 0 32px;
    padding: 0 16px;
  }

  .error-details-text {
    font-size: 20px;
    padding-bottom: 2px;
    color: rgba(255,255,255,0.8);
  }

  .error-details-block {
    min-height: 100px;
    background-color: rgba(0,0,0,0.4);
    padding: 4px 8px;
    overflow-y: auto;
    color: white;
    white-space: pre-wrap;
  }

  .error-actions-block {
    padding: 0 16px;
    display: flex;
    justify-content: flex-end;
  }

  button.error-screen-button,
  a.error-screen-button {
    margin-left: 16px;
    text-transform: uppercase;
    background-color: white;
    font-weight: bolder;
    padding: 8px 12px;
    transition: all 0.15s linear;
    cursor: pointer;
  }

  button.error-screen-button:not(.outline):hover,
  a.error-screen-button:not(.outline):hover {
    background-color: rgba(255,255,255,0.7);
  }

  button.error-screen-button.outline:hover,
  a.error-screen-button.outline:hover {
    background-color: rgba(0,0,0,0.1);
    border-color: rgba(255,255,255,0.7);
  }

  button.error-screen-button.outline,
  a.error-screen-button.outline {
    padding: 6px 8px;
    border: 2px solid white;
    background-color: transparent;
    color: white;
  }

  .fade-enter-active,
  .fade-leave-active {
      transition: opacity 0.5s;
    }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  @media screen and (max-width: 1024px) {
    .error-headline-block {
      .error-title {
        font-size: 40px;
      }
      .error-subtitle {
        font-size: 20px;
      }
      i.error-icon {
        font-size: 70px;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .error-headline-block {
      .error-title-block {
        margin-bottom: -51px;
      }
      .error-title {
        font-size: 30px;
      }

      .error-subtitle {
        font-size: 15px;
      }

      i.error-icon {
        font-size: 60px;
      }
    }
  }

</style>